import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CommonSelectTask from '../../../components/tools/CommonSelectTask/CommonSelectTask';
import { setSelectedTask } from '../../../actions/tools/OrdersSearchActions';
import { getOrderModificationsAreAllowed, getSelectedOrder, selectSelectedToolDomains } from '../../../selectors/tools';

const ASURION_PLATFORM_DOMAIN = 'amazon-A3DB2PB0JZD97C';

const TASK_INPUTS = [
  {
    id: 'orderDetails',
    title: 'Order Summary',
  },
  {
    id: 'asurionCancelRefund',
    title: 'Cancel / Refund Asurion Order',
    conditionFunc: (selectedOrder, state) => {
      const selectedToolDomains = selectSelectedToolDomains(state);
      const isSelectedShopAsurionShop = selectedToolDomains.amazon === ASURION_PLATFORM_DOMAIN;

      return isSelectedShopAsurionShop && getOrderModificationsAreAllowed(state);
    },
  },
];

function mapStateToProps(state) {
  const selectedOrder = getSelectedOrder(state);

  const taskInputsToShow = TASK_INPUTS.filter((taskInput) => {
    return taskInput.conditionFunc ? taskInput.conditionFunc(selectedOrder, state) : true;
  });

  return {
    taskInputs: taskInputsToShow,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setSelectedTask,
    },
    dispatch
  );
};

const AmazonSelectTaskContainer = connect(mapStateToProps, mapDispatchToProps)(CommonSelectTask);

export default AmazonSelectTaskContainer;
